import { render, staticRenderFns } from "./CoPlanCancelAdmin.vue?vue&type=template&id=c9fa3fe8&"
import script from "./CoPlanCancelAdmin.vue?vue&type=script&lang=ts&"
export * from "./CoPlanCancelAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports